export enum PaymentStatusEnum {
  CANCELED = 'CANCELED',
  DELIVERED = 'DELIVERED',
  DIRECT_DEBIT = 'DIRECT_DEBIT',
  IN_PROCESS = 'IN_PROCESS',
  IN_PROCESS_BY_OTHER = 'IN_PROCESS_BY_OTHER',
  IN_QUEUE = 'IN_QUEUE',
  NOT_PAID = 'NOT_PAID',
  OTHER_CANT_BE_PAID = 'OTHER_CANT_BE_PAID',
  PAID = 'PAID',
  PAID_BY_OTHER = 'PAID_BY_OTHER',
  REJECTED = 'REJECTED',
  REJECTED_BY_CUSTOMER = 'REJECTED_BY_CUSTOMER',
  REVIEWED = 'REVIEWED',
  RECEIVED = 'RECEIVED',
  SENT = 'SENT',
  UNKNOWN = 'UNKNOWN',
  NONE = ''
}
